export const getSurveysEndPoint = 'questionnaires';
export const surveyEndPoint = 'surveys';
